import {Injectable, Injector} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {NzMessageService} from "ng-zorro-antd/message";


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    private messageService!: NzMessageService; // Lazy initialization of NzMessageService

  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
            if (!this.messageService) {
                // Lazily loading NzMessageService to avoid circular dependency error
                this.messageService = this.injector.get(NzMessageService);
            }
            const detail = error?.error?.detail;
            const message = typeof detail === 'string' ? detail : (detail?.message ?? null);
            if (error.status === 401) {
                this.messageService.error(message || 'Authentication failed. Please sign in again.');
            } else if (error.status === 400) {
                this.messageService.error(message || (error.error?.detail ?? 'Bad request'));
            } else if (error.status === 500) {
                this.messageService.error(message || 'A server error occurred. Please try again later.');
            }
          return throwError(() => error);
        })
    );
  }
}
